import React, { useState } from 'react';
import { ExpenseForm } from '../components/expenses/ExpenseForm';
import { ExpensesList } from '../components/expenses/ExpensesList';

type ExpenseMode = 'new' | 'history';

export const ExpensesPage: React.FC = () => {
  const [mode, setMode] = useState<ExpenseMode>('new');

  const handleExpenseSuccess = () => {
    setMode('history');
  };

  const tabs: { key: ExpenseMode; label: string }[] = [
    { key: 'new', label: 'Record Expense' },
    { key: 'history', label: 'Expense History' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div style={{ paddingBottom: 20, borderBottom: '1px solid rgba(92,78,51,0.15)' }}>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 400, letterSpacing: '0.4em', textTransform: 'uppercase', color: '#8a8778', marginBottom: 8 }}>
          Finance
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 36, fontWeight: 300, color: '#1c2033', lineHeight: 1 }}>
          Expenses
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 300, color: '#8a8778', marginTop: 8 }}>
          Record expenses paid directly from cash or bank, without going through a bill
        </div>
      </div>

      <div style={{ display: 'flex', gap: 2, background: 'rgba(241,245,249,1)', border: '1px solid rgba(92,78,51,0.2)', borderRadius: 6, padding: 4, width: 'fit-content' }}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setMode(tab.key)}
            style={{
              padding: '8px 20px',
              fontFamily: "'Inter', sans-serif",
              fontSize: 9,
              fontWeight: 500,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              background: mode === tab.key ? 'linear-gradient(135deg, #d97706, #b45309)' : 'transparent',
              color: mode === tab.key ? '#1c2033' : '#8a8778',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { if (mode !== tab.key) (e.currentTarget as HTMLButtonElement).style.color = '#d97706'; }}
            onMouseLeave={e => { if (mode !== tab.key) (e.currentTarget as HTMLButtonElement).style.color = '#8a8778'; }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {mode === 'new' ? (
        <ExpenseForm onSuccess={handleExpenseSuccess} onCancel={() => setMode('history')} />
      ) : (
        <ExpensesList />
      )}
    </div>
  );
};
